import { createSelector } from '@ngrx/store';
import { selectState } from '../../config/selectors';

const selectQuizFeatureState = createSelector(selectState, (state) => state.quiz);

export const selectQuizId = createSelector(selectQuizFeatureState, (state) => state.quizId);
export const selectQuiz = createSelector(selectQuizFeatureState, (state) => state.quiz);
export const selectLoading = createSelector(selectQuizFeatureState, (state) => state.loading);
export const selectLoaded = createSelector(selectQuizFeatureState, (state) => state.loaded);
